import { useEffect, useState, useRef, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';
import StatusBadge from '../components/StatusBadge';
import WorkflowStepper from '../components/WorkflowStepper';
import { DeleteConfirmDialog } from '../components/DeleteConfirmDialog';
import { ReasonDialog } from '../components/ReasonDialog';
import { DueDateCell } from '../utils/dueDate';
import { ReturnedInvoiceFixDialog } from '../components/invoice/ReturnedInvoiceFixDialog';
import { AdminBulkActions } from '../components/AdminBulkActions';
import { InvoiceDetailDialog } from '../components/invoice/InvoiceDetailDialog';
import { SiapProsesDialog } from '../components/invoice/SiapProsesDialog';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Checkbox } from '../components/ui/checkbox';
import { Calendar } from '../components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';
import api from '../lib/api';
import { openPrintWindow, printWhenReady, POPUP_BLOCKED_MESSAGE, escapeHtml, formatRupiah } from '../utils/printHelper';
import { findCompany, signatory, signatureBox, signatureRow, SIGNATURE_STYLE } from '../utils/signatures';
import { computeAmounts, invoiceAmounts } from '../utils/invoiceAmounts';
import { printVoucherInvoice } from '../utils/voucherTemplate';
import { parseUnitPrice, formatUnitPriceInput, formatCurrencyID, parseQuantity, formatQuantityInput, formatQuantity } from '../utils/currency';
import { SearchableSelect } from '../components/SearchableSelect';
import { Pagination } from '../components/Pagination';
import { Plus, Eye, Send, Trash2, Calendar as CalendarIcon, RefreshCw, Pencil, Printer, ArrowUpDown, ArrowUp, ArrowDown, CheckCircle, FileText, Undo2 } from 'lucide-react';
import { toast } from 'sonner';
import { format } from 'date-fns';
import { id } from 'date-fns/locale';



import { VoucherKeteranganDialog } from '../components/invoice/VoucherKeteranganDialog';
import { BuktiTukarDialog } from '../components/invoice/BuktiTukarDialog';
import { TukarFakturDialog } from '../components/invoice/TukarFakturDialog';
import { InvoiceTable } from '../components/invoice/InvoiceTable';
import { InvoiceForm } from '../components/invoice/InvoiceForm';
import { ExportMenu } from '../components/ExportMenu';
export default function Invoices() {
  const { user } = useAuth();
  const [invoices, setInvoices] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [invoiceDate, setInvoiceDate] = useState(null); // Manual invoice date
  const [sortField, setSortField] = useState('invoice_date'); // Default sort by date
  const [sortDirection, setSortDirection] = useState('desc'); // desc = newest first
  const [searchFilter, setSearchFilter] = useState(''); // Search by company, supplier, invoice number
  const [currentPage, setCurrentPage] = useState(1);
  const currentPageRef = useRef(1); // Preserve page across submit/update actions
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [cascadeChildren, setCascadeChildren] = useState(null);
  const [cascadeLoading, setCascadeLoading] = useState(false);
  const [returnTarget, setReturnTarget] = useState(null);
  const [returnLoading, setReturnLoading] = useState(false);
  const [fixTarget, setFixTarget] = useState(null);
  // Tukar Faktur state
  const [showTukarFaktur, setShowTukarFaktur] = useState(false);
  const [tukarFakturInvoice, setTukarFakturInvoice] = useState(null);
  const [tanggalTukar, setTanggalTukar] = useState(null);
  const [catatanTukar, setCatatanTukar] = useState('');
  const [tukarLoading, setTukarLoading] = useState(false);
  // Bukti Tukar state
  const [showBuktiTukar, setShowBuktiTukar] = useState(false);
  const [buktiTukarData, setBuktiTukarData] = useState(null);
  // Siap Proses state (AP input PPh & Admin Bank)
  const [showSiapProses, setShowSiapProses] = useState(false);
  const [siapProsesInvoice, setSiapProsesInvoice] = useState(null);
  const [siapProsesPphType, setSiapProsesPphType] = useState('');
  const [siapProsesPphPercentage, setSiapProsesPphPercentage] = useState(0);
  const [siapProsesAdminBank, setSiapProsesAdminBank] = useState(0);
  const [siapProsesPpnPercentage, setSiapProsesPpnPercentage] = useState(0);
  const [siapProsesPembulatan, setSiapProsesPembulatan] = useState(0);
  const [siapProsesPotonganRetur, setSiapProsesPotonganRetur] = useState(0);
  const [siapProsesLoading, setSiapProsesLoading] = useState(false);
  // Voucher print with keterangan
  const [showVoucherDialog, setShowVoucherDialog] = useState(false);
  const [voucherInvoice, setVoucherInvoice] = useState(null);
  const [voucherKeterangan, setVoucherKeterangan] = useState('');
  
  const today = new Date().toISOString().split('T')[0];
  
  const initialFormState = {
    invoice_number: '',
    supplier_id: '',
    company_id: '',
    email_supplier: '',
    nomor_wa_supplier: '',
    alamat_pengiriman: [''],
    termin_pembayaran: 7,
    jenis_pengiriman: 'full',
    items: [{ name: '', satuan: 'pcs', quantity: 1, quantity_display: '1', unit_price: 0, unit_price_display: '', delivery_date: '' }],
    has_ppn: false,
    ppn_percentage: 11,
    pph_type: '',
    pph_percentage: 0,
    admin_bank: 0,
    notes: ''
  };
  
  const [formData, setFormData] = useState(initialFormState);
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchFilter.trim()), 400);
    return () => clearTimeout(t);
  }, [searchFilter]);

  const fetchInvoices = useCallback(async (page) => {
    const targetPage = typeof page === 'number' ? page : currentPageRef.current;
    try {
      const params = new URLSearchParams({ page: targetPage, limit: 20, sort_by: sortField, sort_dir: sortDirection });
      if (debouncedSearch) params.set('search', debouncedSearch);
      if (statusFilter !== 'all') params.set('status', statusFilter);
      const response = await api.get(`/invoices-full?${params.toString()}`);
      const data = response.data;
      setInvoices(data.items || []);
      setTotalPages(data.total_pages || 1);
      setTotalCount(data.total || 0);
      const newPage = data.page || 1;
      setCurrentPage(newPage);
      currentPageRef.current = newPage;
    } catch (error) {
      console.error('Failed to fetch invoices:', error);
    } finally {
      setLoading(false);
    }
  }, [debouncedSearch, statusFilter, sortField, sortDirection]);

  const fetchSuppliers = useCallback(async () => {
    try {
      const response = await api.get(`/suppliers`);
      setSuppliers(response.data);
    } catch (error) {
      console.error('Failed to fetch suppliers:', error);
    }
  }, []);

  const fetchCompanies = useCallback(async () => {
    try {
      const response = await api.get(`/companies`);
      setCompanies(response.data);
    } catch (error) {
      console.error('Failed to fetch companies:', error);
    }
  }, []);

  useEffect(() => {
    fetchInvoices(1);
  }, [fetchInvoices]);

  useEffect(() => {
    fetchSuppliers();
    fetchCompanies();
  }, [fetchSuppliers, fetchCompanies]);

  // Sorting function (server-side)
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  // Sort icon component
  const SortIcon = ({ field }) => {
    if (sortField !== field) return <ArrowUpDown className="h-4 w-4 text-slate-400" />;
    return sortDirection === 'asc' ? 
      <ArrowUp className="h-4 w-4" style={{ color: '#b8960a' }} /> : 
      <ArrowDown className="h-4 w-4" style={{ color: '#b8960a' }} />;
  };

  // Calculate invoice age (umur hutang) in days
  const getUmurHutang = (invoiceDate) => {
    if (!invoiceDate) return 0;
    const invDate = new Date(invoiceDate);
    const now = new Date();
    const diffTime = now - invDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  // Get umur hutang badge color
  const getUmurBadge = (days) => {
    if (days <= 7) {
      return { label: `${days} hari`, color: 'bg-green-100 text-green-700', status: 'DALAM BATAS' };
    } else if (days <= 14) {
      return { label: `${days} hari`, color: 'bg-amber-100 text-amber-700', status: 'PEMANTAUAN' };
    } else {
      return { label: `${days} hari`, color: 'bg-red-100 text-red-700 font-bold', status: 'LEWAT BATAS' };
    }
  };

  // Revert invoice to previous status
  const handleRevertInvoice = async (invoiceId) => {
    try {
      const res = await api.patch(`/invoices-full/${invoiceId}/revert`, { reason: '' });
      toast.success(res.data.message);
      fetchInvoices();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mengembalikan invoice');
    }
  };

  // Submit to payment request (Siap Proses) - now opens dialog
  const openSiapProses = (invoice) => {
    setSiapProsesInvoice(invoice);
    // Pre-fill with existing values if any
    setSiapProsesPphType(invoice.pph_type || '');
    setSiapProsesPphPercentage(invoice.pph_percentage || 0);
    setSiapProsesAdminBank(invoice.admin_bank || 0);
    setSiapProsesPpnPercentage(invoice.ppn_percentage || 11);
    setSiapProsesPembulatan(invoice.pembulatan || 0);
    setSiapProsesPotonganRetur(invoice.potongan_retur || 0);
    setShowSiapProses(true);
  };

  const handleSubmitToPayment = async () => {
    if (!siapProsesInvoice) return;
    setSiapProsesLoading(true);
    try {
      await api.patch(`/invoices-full/${siapProsesInvoice.id}/submit-to-payment`, {
        pph_type: siapProsesPphType || null,
        pph_percentage: siapProsesPphPercentage || 0,
        admin_bank: siapProsesAdminBank || 0,
        ppn_percentage: siapProsesPpnPercentage || 0,
        pembulatan: siapProsesPembulatan || 0,
        potongan_retur: siapProsesPotonganRetur || 0
      });
      toast.success('Invoice berhasil dipindahkan ke Payment Request');
      setShowSiapProses(false);
      setSiapProsesInvoice(null);
      fetchInvoices();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal memproses invoice');
    } finally {
      setSiapProsesLoading(false);
    }
  };

  // Admin delete function
  const openDeleteDialog = async (invoice) => {
    setItemToDelete(invoice);
    setCascadeChildren(null);
    setDeleteDialogOpen(true);
    setCascadeLoading(true);
    try {
      const r = await api.get(`/admin/transactions/invoice_full/${invoice.id}/cascade-preview`);
      setCascadeChildren(r.data.children || []);
    } catch (e) {
      setCascadeChildren([]);
    } finally {
      setCascadeLoading(false);
    }
  };

  // AP: kembalikan invoice Submitted ke clerk
  const handleReturnToClerk = async (reason) => {
    if (!returnTarget) return;
    setReturnLoading(true);
    try {
      await api.patch(`/invoices-full/${returnTarget.id}/return-to-clerk`, { alasan: reason });
      toast.success(`Invoice ${returnTarget.invoice_number} dikembalikan ke clerk`);
      setReturnTarget(null);
      fetchInvoices();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mengembalikan invoice');
    } finally {
      setReturnLoading(false);
    }
  };

  // Clerk: hapus invoice yang dikembalikan
  const handleDeleteReturned = async (invoice) => {
    if (!window.confirm(`Hapus invoice ${invoice.invoice_number} yang dikembalikan? PO akan dibuka kembali.`)) return;
    try {
      await api.delete(`/invoices-full/${invoice.id}`);
      toast.success(`Invoice ${invoice.invoice_number} dihapus`);
      fetchInvoices();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal menghapus invoice');
    }
  };

  const canFixReturned = (invoice) => user?.role === 'admin' || (['staff_clerk', 'purchasing'].includes(user?.role) && invoice.created_by === user?.id);

  const handleDelete = async (reason) => {
    if (!itemToDelete) return;
    
    setDeleteLoading(true);
    try {
      await api.delete(`/admin/transactions/invoice_full/${itemToDelete.id}`, {
        data: { reason }
      });
      toast.success(`Invoice ${itemToDelete.invoice_number} berhasil dihapus`);
      setDeleteDialogOpen(false);
      setItemToDelete(null);
      fetchInvoices();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal menghapus invoice');
    } finally {
      setDeleteLoading(false);
    }
  };

  // Tukar Faktur functions
  const openTukarFaktur = (invoice) => {
    setTukarFakturInvoice(invoice);
    setTanggalTukar(new Date());
    setCatatanTukar('');
    setShowTukarFaktur(true);
  };

  const handleTukarFaktur = async () => {
    if (!tukarFakturInvoice || !tanggalTukar) {
      toast.error('Pilih tanggal tukar faktur');
      return;
    }

    setTukarLoading(true);
    try {
      const response = await api.patch(`/invoices-full/${tukarFakturInvoice.id}/tukar-faktur`, {
        tanggal_tukar: format(tanggalTukar, 'yyyy-MM-dd'),
        catatan: catatanTukar
      });
      toast.success(`Tukar Faktur berhasil! No. Bukti: ${response.data.bukti_tukar_number}`);
      setShowTukarFaktur(false);
      setTukarFakturInvoice(null);
      fetchInvoices();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal tukar faktur');
    } finally {
      setTukarLoading(false);
    }
  };

  const handlePrintBuktiTukar = async (invoiceId) => {
    try {
      const response = await api.get(`/invoices-full/${invoiceId}/bukti-tukar`);
      setBuktiTukarData(response.data);
      setShowBuktiTukar(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mengambil data bukti tukar');
    }
  };

  const printBuktiTukarFaktur = () => {
    if (!buktiTukarData) return;
    
    const a = invoiceAmounts(buktiTukarData);

    const printWindow = openPrintWindow(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Bukti Tukar Faktur - ${buktiTukarData.bukti_tukar_number}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 30px; text-transform: uppercase; font-size: 11pt; }
          .header { text-align: center; margin-bottom: 30px; border-bottom: 3px solid #16a34a; padding-bottom: 20px; }
          .header h1 { margin: 0; color: #16a34a; font-size: 18pt; font-weight: bold; }
          .header h2 { margin: 10px 0 0 0; color: #334155; font-size: 14pt; }
          .info-section { margin-bottom: 20px; }
          .info-row { display: flex; margin-bottom: 8px; }
          .info-label { width: 220px; font-weight: bold; }
          .info-value { flex: 1; }
          .total-section { margin: 25px 0; padding: 15px; border: 2px solid #16a34a; border-radius: 6px; background: #f0fdf4; }
          .total-row { display: flex; justify-content: space-between; margin-bottom: 6px; font-size: 11pt; }
          .total-row.final { font-size: 14pt; font-weight: bold; color: #16a34a; border-top: 2px solid #16a34a; padding-top: 10px; margin-top: 10px; }
          ${SIGNATURE_STYLE}
          @media print { body { print-color-adjust: exact; -webkit-print-color-adjust: exact; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>BUKTI TANDA TERIMA TUKAR FAKTUR</h1>
          <h2>${buktiTukarData.bukti_tukar_number}</h2>
        </div>
        
        <div class="info-section">
          <div class="info-row">
            <div class="info-label">NO. INVOICE:</div>
            <div class="info-value">${buktiTukarData.invoice_number}</div>
          </div>
          <div class="info-row">
            <div class="info-label">TANGGAL INVOICE:</div>
            <div class="info-value">${new Date(buktiTukarData.invoice_date).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).toUpperCase()}</div>
          </div>
          <div class="info-row">
            <div class="info-label">TANGGAL TUKAR FAKTUR:</div>
            <div class="info-value">${new Date(buktiTukarData.tanggal_tukar).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).toUpperCase()}</div>
          </div>
          <div class="info-row">
            <div class="info-label">SUPPLIER:</div>
            <div class="info-value">${buktiTukarData.supplier_name}</div>
          </div>
          <div class="info-row">
            <div class="info-label">PERUSAHAAN:</div>
            <div class="info-value">${buktiTukarData.company_name}</div>
          </div>
          ${buktiTukarData.po_number ? `
          <div class="info-row">
            <div class="info-label">NO. PO:</div>
            <div class="info-value">${buktiTukarData.po_number}</div>
          </div>
          ` : ''}
        </div>
        
        <div class="total-section">
          <div class="total-row"><span>SUBTOTAL</span><span>Rp ${formatRupiah(a.subtotal)}</span></div>
          ${a.potonganRetur > 0 ? `<div class="total-row"><span>POTONGAN / RETUR</span><span>(Rp ${formatRupiah(a.potonganRetur)})</span></div>` : ''}
          ${a.ppnAmount > 0 ? `<div class="total-row"><span>PPN ${a.ppnPercentage || 11}%</span><span>Rp ${formatRupiah(a.ppnAmount)}</span></div>` : ''}
          ${a.biayaAngkut > 0 ? `<div class="total-row"><span>BIAYA ANGKUT</span><span>Rp ${formatRupiah(a.biayaAngkut)}</span></div>` : ''}
          ${a.pembulatan !== 0 ? `<div class="total-row"><span>PEMBULATAN</span><span>Rp ${formatRupiah(a.pembulatan)}</span></div>` : ''}
          ${a.dpAmount > 0 ? `<div class="total-row"><span>DOWN PAYMENT</span><span>(Rp ${formatRupiah(a.dpAmount)})</span></div>` : ''}
          <div class="total-row"><span>TOTAL TAGIHAN</span><span>Rp ${formatRupiah(a.totalTagihan)}</span></div>
          ${a.pphAmount > 0 ? `<div class="total-row"><span>${a.pphType} ${a.pphPercentage}%</span><span>(Rp ${formatRupiah(a.pphAmount)})</span></div>` : ''}
          ${a.adminBank > 0 ? `<div class="total-row"><span>ADMIN BANK</span><span>(Rp ${formatRupiah(a.adminBank)})</span></div>` : ''}
          <div class="total-row final"><span>NILAI DIBAYARKAN</span><span>Rp ${formatRupiah(a.nilaiDibayarkan)}</span></div>
        </div>
        
        ${buktiTukarData.catatan ? `
        <div class="info-section">
          <div class="info-row">
            <div class="info-label">CATATAN:</div>
            <div class="info-value">${buktiTukarData.catatan}</div>
          </div>
        </div>
        ` : ''}
        
        ${signatureRow([
          signatureBox('DISERAHKAN OLEH', (buktiTukarData.supplier_name || '').toUpperCase()),
          signatureBox('DITERIMA OLEH', (user?.name || '').toUpperCase()),
        ])}
      </body>
      </html>
    `);
    if (!printWindow) {
      toast.error(POPUP_BLOCKED_MESSAGE);
      return;
    }
    printWhenReady(printWindow);
  };

  // Voucher printing lives in utils/voucherTemplate.js so every screen prints
  // exactly the same numbers.
  const printVoucherPembayaran = (invoice, keteranganTambahan = '') =>
    printVoucherInvoice(invoice, keteranganTambahan, {
      company: findCompany(companies, invoice.company_id),
      printedBy: (user?.name || '').toUpperCase(),
    });

  const handleAddItem = () => {
    setFormData({
      ...formData,
      items: [...formData.items, { name: '', satuan: 'pcs', quantity: 1, quantity_display: '1', unit_price: 0, unit_price_display: '', delivery_date: '' }]
    });
  };

  const handleRemoveItem = (index) => {
    const newItems = formData.items.filter((_, i) => i !== index);
    setFormData({ ...formData, items: newItems });
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...formData.items];
    if (field === 'name') {
      newItems[index][field] = value.toUpperCase();
    } else if (field === 'delivery_date' || field === 'satuan') {
      newItems[index][field] = value;
    } else if (field === 'quantity') {
      // Display-string pattern: separators survive while the user is typing.
      const displayValue = formatQuantityInput(value);
      newItems[index].quantity = Math.max(1, parseQuantity(displayValue));
      newItems[index].quantity_display = displayValue;
    } else if (field === 'unit_price') {
      const displayValue = formatUnitPriceInput(value);
      newItems[index].unit_price = parseUnitPrice(displayValue);
      newItems[index].unit_price_display = displayValue;
    }
    setFormData({ ...formData, items: newItems });
  };

  const handleAddAddress = () => {
    setFormData({
      ...formData,
      alamat_pengiriman: [...formData.alamat_pengiriman, '']
    });
  };

  const handleRemoveAddress = (index) => {
    const newAddresses = formData.alamat_pengiriman.filter((_, i) => i !== index);
    setFormData({ ...formData, alamat_pengiriman: newAddresses });
  };

  const handleAddressChange = (index, value) => {
    const newAddresses = [...formData.alamat_pengiriman];
    newAddresses[index] = value.toUpperCase();
    setFormData({ ...formData, alamat_pengiriman: newAddresses });
  };

  const handleSupplierChange = (supplierId) => {
    const supplier = suppliers.find(s => s.id === supplierId);
    setFormData({ 
      ...formData, 
      supplier_id: supplierId,
      email_supplier: supplier?.email?.toLowerCase() || '',
      nomor_wa_supplier: supplier?.nomor_wa || ''
    });
  };

  const resetForm = () => {
    setFormData(initialFormState);
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    
    if (!formData.invoice_number.trim()) {
      toast.error('Masukkan nomor invoice');
      return;
    }
    if (!formData.supplier_id) {
      toast.error('Pilih supplier terlebih dahulu');
      return;
    }
    if (!formData.company_id) {
      toast.error('Pilih perusahaan tujuan terlebih dahulu');
      return;
    }
    if (!invoiceDate) {
      toast.error('Pilih tanggal invoice');
      return;
    }
    
    const validAddresses = formData.alamat_pengiriman.filter(addr => addr.trim() !== '');
    if (validAddresses.length === 0) {
      toast.error('Masukkan minimal satu alamat pengiriman');
      return;
    }

    try {
      const submitData = {
        ...formData,
        pph_type: formData.pph_type || null,
        invoice_number: formData.invoice_number.trim().toUpperCase(),
        invoice_date: format(invoiceDate, 'yyyy-MM-dd'),
        alamat_pengiriman: validAddresses,
        items: formData.items.map(item => ({
          name: item.name,
          satuan: item.satuan,
          quantity: item.quantity,
          unit_price: item.unit_price,
          delivery_date: item.delivery_date
        }))
      };
      delete submitData.unit_price_display;
      await api.post(`/invoices-full`, submitData);
      toast.success('Invoice berhasil dibuat!');
      setShowCreate(false);
      resetForm();
      setInvoiceDate(null);
      fetchInvoices();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal membuat invoice');
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    
    if (!selectedInvoice) return;
    
    const validAddresses = formData.alamat_pengiriman.filter(addr => addr.trim() !== '');
    if (validAddresses.length === 0) {
      toast.error('Masukkan minimal satu alamat pengiriman');
      return;
    }

    try {
      const submitData = {
        ...formData,
        pph_type: formData.pph_type || null,
        invoice_date: invoiceDate ? format(invoiceDate, 'yyyy-MM-dd') : undefined,
        alamat_pengiriman: validAddresses,
        items: formData.items.map(item => ({
          name: item.name,
          satuan: item.satuan,
          quantity: item.quantity,
          unit_price: item.unit_price,
          delivery_date: item.delivery_date
        }))
      };
      delete submitData.unit_price_display;
      await api.put(`/invoices-full/${selectedInvoice.id}`, submitData);
      toast.success('Invoice berhasil diupdate!');
      setShowEdit(false);
      resetForm();
      fetchInvoices();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal update invoice');
    }
  };

  const openEdit = (invoice) => {
    setSelectedInvoice(invoice);
    setFormData({
      supplier_id: invoice.supplier_id || '',
      company_id: invoice.company_id || '',
      email_supplier: invoice.email_supplier || invoice.supplier_data?.email || '',
      nomor_wa_supplier: invoice.nomor_wa_supplier || invoice.supplier_data?.nomor_wa || '',
      alamat_pengiriman: invoice.alamat_pengiriman || [''],
      termin_pembayaran: invoice.termin_pembayaran || 7,
      jenis_pengiriman: invoice.jenis_pengiriman || 'full',
      items: (invoice.items || []).map(item => ({
        name: item.name || '',
        satuan: item.satuan || 'pcs',
        quantity: item.quantity || 1,
        quantity_display: formatQuantity(item.quantity || 1),
        unit_price: item.unit_price || 0,
        unit_price_display: formatCurrencyID(item.unit_price || 0),
        delivery_date: item.delivery_date || ''
      })),
      has_ppn: invoice.has_ppn || false,
      ppn_percentage: invoice.ppn_percentage || 11,
      pph_type: invoice.pph_type || '',
      pph_percentage: invoice.pph_percentage || 0,
      admin_bank: invoice.admin_bank || 0,
      notes: invoice.notes || ''
    });
    setInvoiceDate(invoice.invoice_date ? new Date(invoice.invoice_date) : null);
    setShowEdit(true);
  };

  const handleSubmit = async (invoiceId) => {
    try {
      await api.patch(`/invoices-full/${invoiceId}/submit`);
      toast.success('Invoice berhasil disubmit!');
      fetchInvoices();
    } catch (error) {
      toast.error('Gagal submit invoice');
    }
  };

  const handlePrint = (invoice) => {
    const a = invoiceAmounts(invoice);
    // Dibaca dari master, bukan salinan beku invoice.company_data.
    const invFat = signatory(findCompany(companies, invoice.company_id), 'fat');
    const printWindow = openPrintWindow(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>${invoice.invoice_number}</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Calibri:wght@400;700&display=swap');
          body { font-family: Calibri, 'Segoe UI', Tahoma, sans-serif; padding: 20px; text-transform: uppercase; font-size: 10pt; }
          .header { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #ea580c; padding-bottom: 15px; }
          .header h1 { margin: 0; color: #ea580c; font-size: 16pt; font-weight: bold; }
          .header h2 { margin: 8px 0 0 0; color: #334155; font-size: 14pt; font-weight: bold; }
          .inv-info { display: flex; justify-content: space-between; margin-bottom: 15px; }
          .inv-info div { width: 48%; }
          .inv-info p { margin: 4px 0; font-size: 10pt; }
          .inv-info strong { font-size: 11pt; }
          .section { margin-bottom: 15px; }
          .section-title { font-weight: bold; background: #fff7ed; padding: 6px 8px; margin-bottom: 8px; font-size: 11pt; color: #ea580c; }
          .section p { font-size: 10pt; margin: 3px 0; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
          th { border: 1px solid #fed7aa; padding: 6px 8px; text-align: left; background: #fff7ed; font-size: 11pt; font-weight: bold; }
          td { border: 1px solid #fed7aa; padding: 6px 8px; text-align: left; font-size: 10pt; }
          .text-right { text-align: right; }
          .text-center { text-align: center; }
          .total-section { background: #fff7ed; padding: 12px; border-radius: 6px; border: 1px solid #fed7aa; }
          .total-row { display: flex; justify-content: space-between; margin-bottom: 4px; font-size: 10pt; }
          .total-row strong { font-size: 11pt; }
          .total-final { font-size: 12pt; font-weight: bold; color: #ea580c; border-top: 2px solid #ea580c; padding-top: 8px; margin-top: 8px; }
          ${SIGNATURE_STYLE}
          .lowercase { text-transform: lowercase; }
          .normal-case { text-transform: none; }
          @media print { body { print-color-adjust: exact; -webkit-print-color-adjust: exact; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>INVOICE</h1>
          <h2>${(invoice.company_name || '-').toUpperCase()}</h2>
        </div>
        
        <div class="inv-info">
          <div>
            <p><strong>NO. INVOICE:</strong> ${invoice.invoice_number}</p>
            <p><strong>TANGGAL:</strong> ${new Date(invoice.invoice_date).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).toUpperCase()}</p>
            <p><strong>TERMIN:</strong> ${invoice.termin_pembayaran || '-'} HARI</p>
            <p><strong>JENIS PENGIRIMAN:</strong> ${invoice.jenis_pengiriman === 'full' ? 'FULL (SEKALIGUS)' : 'PARTIAL (BERTAHAP)'}</p>
          </div>
          <div>
            <p><strong>SUPPLIER:</strong> ${(invoice.supplier_name || '').toUpperCase()}</p>
            <p><strong>EMAIL:</strong> <span class="lowercase">${invoice.email_supplier || invoice.supplier_data?.email || '-'}</span></p>
            <p><strong>NO. WA:</strong> ${invoice.nomor_wa_supplier || invoice.supplier_data?.nomor_wa || '-'}</p>
          </div>
        </div>
        
        <div class="section">
          <div class="section-title">ALAMAT PENGIRIMAN</div>
          ${(invoice.alamat_pengiriman || []).map((addr, i) => `<p>${i + 1}. ${addr.toUpperCase()}</p>`).join('')}
        </div>
        
        <div class="section">
          <div class="section-title">DAFTAR ITEMS</div>
          <table>
            <thead>
              <tr>
                <th class="text-center" style="width: 40px;">NO</th>
                <th>NAMA ITEM</th>
                <th class="text-center" style="width: 70px;">SATUAN</th>
                <th class="text-center" style="width: 80px;">QTY</th>
                <th class="text-right" style="width: 120px;">HARGA SATUAN</th>
                <th class="text-right" style="width: 120px;">JUMLAH</th>
                ${invoice.jenis_pengiriman === 'partial' ? '<th style="width: 100px;">TGL KIRIM</th>' : ''}
              </tr>
            </thead>
            <tbody>
              ${(invoice.items || []).map((item, i) => `
                <tr>
                  <td class="text-center">${i + 1}</td>
                  <td>${(item.name || '').toUpperCase()}</td>
                  <td class="text-center">${(item.satuan || 'PCS').toUpperCase()}</td>
                  <td class="text-center normal-case">${(item.quantity || 0).toLocaleString('id-ID')}</td>
                  <td class="text-right normal-case">Rp ${formatRupiah(item.unit_price || 0)}</td>
                  <td class="text-right normal-case">Rp ${formatRupiah((item.quantity || 0) * (item.unit_price || 0))}</td>
                  ${invoice.jenis_pengiriman === 'partial' ? `<td class="text-center">${item.delivery_date ? new Date(item.delivery_date).toLocaleDateString('id-ID') : '-'}</td>` : ''}
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
        
        <div class="total-section">
          <div class="total-row">
            <strong>SUBTOTAL</strong>
            <span class="normal-case">Rp ${formatRupiah(a.subtotal)}</span>
          </div>
          ${a.potonganRetur > 0 ? `
            <div class="total-row">
              <strong>POTONGAN / RETUR</strong>
              <span class="normal-case">(Rp ${formatRupiah(a.potonganRetur)})</span>
            </div>
          ` : ''}
          ${a.hasPpn ? `
            <div class="total-row">
              <strong>PPN (${a.ppnPercentage}%)</strong>
              <span class="normal-case">Rp ${formatRupiah(a.ppnAmount)}</span>
            </div>
          ` : ''}
          ${a.biayaAngkut > 0 ? `
            <div class="total-row">
              <strong>BIAYA ANGKUT</strong>
              <span class="normal-case">Rp ${formatRupiah(a.biayaAngkut)}</span>
            </div>
          ` : ''}
          ${a.pembulatan !== 0 ? `
            <div class="total-row">
              <strong>PEMBULATAN</strong>
              <span class="normal-case">Rp ${formatRupiah(a.pembulatan)}</span>
            </div>
          ` : ''}
          ${a.dpAmount > 0 ? `
            <div class="total-row">
              <strong>DOWN PAYMENT</strong>
              <span class="normal-case">(Rp ${formatRupiah(a.dpAmount)})</span>
            </div>
          ` : ''}
          <div class="total-row">
            <strong>TOTAL TAGIHAN</strong>
            <span class="normal-case">Rp ${formatRupiah(a.totalTagihan)}</span>
          </div>
          ${a.pphAmount > 0 ? `
            <div class="total-row">
              <strong>PPH (${a.pphType} ${a.pphPercentage}%)</strong>
              <span class="normal-case">(Rp ${formatRupiah(a.pphAmount)})</span>
            </div>
          ` : ''}
          ${a.adminBank > 0 ? `
            <div class="total-row">
              <strong>ADMIN BANK</strong>
              <span class="normal-case">(Rp ${formatRupiah(a.adminBank)})</span>
            </div>
          ` : ''}
          <div class="total-row total-final">
            <span>NILAI DIBAYARKAN</span>
            <span class="normal-case">Rp ${formatRupiah(a.nilaiDibayarkan)}</span>
          </div>
        </div>
        
        ${invoice.notes ? `
          <div class="section">
            <div class="section-title">CATATAN</div>
            <p>${invoice.notes.toUpperCase()}</p>
          </div>
        ` : ''}
        
        ${signatureRow([
          signatureBox('DIBUAT OLEH', (invoice.created_by_name || '').toUpperCase()),
          signatureBox('DISETUJUI OLEH', invFat.nama, invFat.jabatan),
        ])}
      </body>
      </html>
    `);
    if (!printWindow) {
      toast.error(POPUP_BLOCKED_MESSAGE);
      return;
    }
    printWhenReady(printWindow);
  };

  // Calculations - shared with the backend, the detail dialogs and the voucher
  const formAmounts = computeAmounts({
    subtotal: formData.items.reduce((sum, item) => sum + (item.quantity * item.unit_price), 0),
    hasPpn: formData.has_ppn,
    ppnPercentage: formData.ppn_percentage,
    pphType: formData.pph_type,
    pphPercentage: formData.pph_percentage,
    adminBank: formData.admin_bank,
  });
  const { subtotal, ppnAmount, pphAmount, adminBank, totalTagihan, nilaiDibayarkan } = formAmounts;

  // Form component (reusable for create and edit)
  const renderForm = (isEdit = false) => (
    <InvoiceForm formAmounts={formAmounts} companies={companies} formData={formData} handleAddAddress={handleAddAddress} handleAddItem={handleAddItem} handleAddressChange={handleAddressChange} handleCreate={handleCreate} handleEdit={handleEdit} handleItemChange={handleItemChange} handleRemoveAddress={handleRemoveAddress} handleRemoveItem={handleRemoveItem} handleSupplierChange={handleSupplierChange} invoiceDate={invoiceDate} isEdit={isEdit} selectedInvoice={selectedInvoice} setFormData={setFormData} setInvoiceDate={setInvoiceDate} suppliers={suppliers} />
  );

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-96">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6" data-testid="invoices-page">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>Invoices</h1>
          <div className="flex gap-2">
            <Button variant="outline" onClick={fetchInvoices} data-testid="refresh-invoice-button">
              <RefreshCw className="mr-2 h-4 w-4" /> Refresh
            </Button>
            {['purchasing', 'staff_clerk', 'admin'].includes(user?.role) && (
              <Dialog open={showCreate} onOpenChange={(open) => { setShowCreate(open); if (!open) resetForm(); }}>
                <DialogTrigger asChild>
                  <Button data-testid="create-invoice-button" className="bg-orange-600 hover:bg-orange-700">
                    <Plus className="mr-2 h-4 w-4" /> Buat Invoice Baru
                  </Button>
                </DialogTrigger>
                <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
                  <DialogHeader>
                    <DialogTitle>Buat Invoice Baru</DialogTitle>
                    <p className="text-sm text-slate-600">Isi form untuk membuat Invoice baru</p>
                  </DialogHeader>
                  {renderForm(false)}
                </DialogContent>
              </Dialog>
            )}
          </div>
        </div>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between">
            <CardTitle>Daftar Invoices</CardTitle>
            <div className="flex items-center gap-2">
              <Input
                placeholder="Cari invoice, supplier, perusahaan..."
                value={searchFilter}
                onChange={(e) => setSearchFilter(e.target.value)}
                className="w-72 h-9"
                data-testid="invoice-search-filter"
              />
              <Select value={statusFilter} onValueChange={setStatusFilter}>
                <SelectTrigger className="w-44 h-9" data-testid="invoice-status-filter">
                  <SelectValue placeholder="Semua Status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Semua Status</SelectItem>
                  <SelectItem value="draft">Draft</SelectItem>
                  <SelectItem value="submitted">Submitted</SelectItem>
                  <SelectItem value="proses_bayar">Proses Bayar</SelectItem>
                  <SelectItem value="bank_process">Bank Process</SelectItem>
                  <SelectItem value="terbayar">Terbayar</SelectItem>
                </SelectContent>
              </Select>
              <ExportMenu table="invoices" params={{ search: debouncedSearch, status: statusFilter, sort_by: sortField, sort_dir: sortDirection }} />
              {user?.role === 'admin' && (
                <AdminBulkActions collectionType="invoices_full" collectionLabel="Invoice" onRefresh={fetchInvoices} />
              )}
            </div>
          </CardHeader>
          <InvoiceTable SortIcon={SortIcon} canFixReturned={canFixReturned} currentPage={currentPage} fetchInvoices={fetchInvoices} getUmurBadge={getUmurBadge} getUmurHutang={getUmurHutang} handleDeleteReturned={handleDeleteReturned} handlePrint={handlePrint} handlePrintBuktiTukar={handlePrintBuktiTukar} handleRevertInvoice={handleRevertInvoice} handleSort={handleSort} handleSubmit={handleSubmit} invoices={invoices} openDeleteDialog={openDeleteDialog} openEdit={openEdit} openSiapProses={openSiapProses} openTukarFaktur={openTukarFaktur} setFixTarget={setFixTarget} setReturnTarget={setReturnTarget} setSelectedInvoice={setSelectedInvoice} setShowDetail={setShowDetail} setShowVoucherDialog={setShowVoucherDialog} setVoucherInvoice={setVoucherInvoice} setVoucherKeterangan={setVoucherKeterangan} sortField={sortField} totalCount={totalCount} totalPages={totalPages} user={user} />
        </Card>

        {/* Delete Confirmation Dialog */}
        <DeleteConfirmDialog
          open={deleteDialogOpen}
          onOpenChange={setDeleteDialogOpen}
          onConfirm={handleDelete}
          title="Hapus Invoice"
          description="Apakah Anda yakin ingin menghapus invoice ini? Tindakan ini tidak dapat dibatalkan dan akan dicatat dalam log penghapusan."
          itemName={itemToDelete ? `${itemToDelete.invoice_number} - ${itemToDelete.supplier_name} - Rp ${itemToDelete.total_amount?.toLocaleString('id-ID')}` : ''}
          loading={deleteLoading}
          cascadeChildren={cascadeChildren}
          cascadeLoading={cascadeLoading}
        />

        <ReasonDialog
          open={!!returnTarget}
          onOpenChange={(v) => { if (!v) setReturnTarget(null); }}
          onConfirm={handleReturnToClerk}
          loading={returnLoading}
          testId="return-invoice-dialog"
          title="Kembalikan Invoice ke Clerk"
          description="Invoice akan berstatus Dikembalikan. PO dibuka kembali, qty & biaya angkut dilepas, dan DP yang terserap bisa dipotong lagi."
          itemName={returnTarget ? `${returnTarget.invoice_number} - ${returnTarget.supplier_name}` : ''}
          confirmLabel="Kembalikan"
          confirmClassName="bg-orange-600 hover:bg-orange-700"
        />

        <ReturnedInvoiceFixDialog
          open={!!fixTarget}
          onOpenChange={(v) => { if (!v) setFixTarget(null); }}
          invoice={fixTarget}
          onDone={fetchInvoices}
        />

        {/* Edit Dialog */}
        <Dialog open={showEdit} onOpenChange={(open) => { setShowEdit(open); if (!open) resetForm(); }}>
          <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>Edit Invoice</DialogTitle>
              <p className="text-sm text-slate-600">Update data Invoice {selectedInvoice?.invoice_number}</p>
            </DialogHeader>
            {renderForm(true)}
          </DialogContent>
        </Dialog>

        {/* Detail Dialog */}
        <InvoiceDetailDialog
          open={showDetail}
          onOpenChange={setShowDetail}
          invoice={selectedInvoice}
          onPrint={null}
        />

        <TukarFakturDialog catatanTukar={catatanTukar} handleTukarFaktur={handleTukarFaktur} setCatatanTukar={setCatatanTukar} setShowTukarFaktur={setShowTukarFaktur} setTanggalTukar={setTanggalTukar} showTukarFaktur={showTukarFaktur} tanggalTukar={tanggalTukar} tukarFakturInvoice={tukarFakturInvoice} tukarLoading={tukarLoading} />

        <BuktiTukarDialog buktiTukarData={buktiTukarData} printBuktiTukarFaktur={printBuktiTukarFaktur} setShowBuktiTukar={setShowBuktiTukar} showBuktiTukar={showBuktiTukar} />

        {/* Siap Proses Dialog */}
        <SiapProsesDialog
          open={showSiapProses}
          onOpenChange={setShowSiapProses}
          invoice={siapProsesInvoice}
          pphType={siapProsesPphType}
          setPphType={setSiapProsesPphType}
          pphPercentage={siapProsesPphPercentage}
          setPphPercentage={setSiapProsesPphPercentage}
          adminBank={siapProsesAdminBank}
          setAdminBank={setSiapProsesAdminBank}
          ppnPercentage={siapProsesPpnPercentage}
          setPpnPercentage={setSiapProsesPpnPercentage}
          pembulatan={siapProsesPembulatan}
          setPembulatan={setSiapProsesPembulatan}
          potonganRetur={siapProsesPotonganRetur}
          setPotonganRetur={setSiapProsesPotonganRetur}
          onSubmit={handleSubmitToPayment}
          loading={siapProsesLoading}
        />

        <VoucherKeteranganDialog printVoucherPembayaran={printVoucherPembayaran} setShowVoucherDialog={setShowVoucherDialog} setVoucherKeterangan={setVoucherKeterangan} showVoucherDialog={showVoucherDialog} voucherInvoice={voucherInvoice} voucherKeterangan={voucherKeterangan} />
      </div>
    </Layout>
  );
}



